module.exports = __webpack_public_path__ + "media/images/diagonal-arrow-cda3eb4028b4f51896d9f6f232499b5d.svg";